import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ModalController, LoadingController, ViewController } from 'ionic-angular';
import { CuentasPorCobrarProvider } from '../../providers/cuentas-por-cobrar/cuentas-por-cobrar'
import { CajaProvider } from '../../providers/caja/caja'
import { File } from '@ionic-native/file';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { UtilsProvider } from '../../providers/utils/utils'
import { AuthService } from '../../providers/auth-service';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DianProvider } from '../../providers/dian/dian';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { State } from '../../store/app.reducer'
import { Store } from '@ngrx/store';
import { UtilsRedux } from '../../providers/redux/utils/utils';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { Storage } from '@ionic/storage'
import { InformesProvider } from '../../providers/informes/informes';

type AOA = any[][];
@IonicPage()
@Component({
  selector: 'page-cuentas-por-cobrar-creditos-visualizar-plan-de-pagos',
  templateUrl: 'cuentas-por-cobrar-creditos-visualizar-plan-de-pagos.html',
  providers: [ ClienteSelectRedux, UtilsRedux,File,InAppBrowser, AuthService, ParametrosGeneralesRedux, DianProvider ]
})

export class CuentasPorCobrarCreditosVisualizarPlanDePagosPage {

  @Input() arrayWhereLocal: any = []
  public clientesId:any
  recibo:string = "";
  pagoTotal:boolean=false
  datosCredito = []
  datosCreditoTemporal = []
  clienteId = []
  valoresTotales = []
  valorPagado:number = 0
  valorPendiente:number = 0
  data: any[][]
  companiasId;
  bluetooth:boolean = false
  fechaPagoReal:Date
  detalle:string = ''
  comprobantePago:string = ''
  listaClientes = [];
  valoresCliente: string = 'Buscar Cliente';
  isLoading: boolean = false;
  public isButtonDisabledCliente: boolean = false;
  public isButtonDisabledPago: boolean = false;
  interesCreditos:any[] = []
  planDePagos:any[]=[]
  datacliente:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  mostrarGrid: boolean= true;
  cliente: string = ''
  planDePagosCuentaPorCobrar:any[]=[]
  calcularValoresCuentaPorCobrar:any[]=[]
  cargando: boolean = true;
  progreso: number = 0;
  resultados: any[] = [];
  factura:string = ''
  itemPlanDePagos: any = { totalPagoActual: 0 };
  mostrarPlanDePagos: boolean = false;
  cuentasPorCobrarId:any = ""
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public buscarCuentasPorCobrarProvider:CuentasPorCobrarProvider,
              public servicio:CajaProvider,
              public alertControllers: AlertController,
              public file: File,private iab: InAppBrowser,
              public utils: UtilsProvider,
              public auth: AuthService,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public dian: DianProvider,
              private store:Store<State>,
              public modalControllers: ModalController
              ,public utilsRedux: UtilsRedux,
              public clienteSelectRedux: ClienteSelectRedux,
              public loadingCtrl: LoadingController,
              public viewCtrl: ViewController,
              private storage: Storage,
              public servicioDescargar: InformesProvider) {
                if(this.navParams.get('data')){
                  this.cuentasPorCobrarId = this.navParams.get('data')
                  console.log(this.cuentasPorCobrarId)
                  this.buscarCalcularValoresCuentaPorCobrar(this.cuentasPorCobrarId)
                }
  }

cerrarSession() {
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}

closePlanDePagos() {
  this.viewCtrl.dismiss();
}

async buscarCalcularValoresCuentaPorCobrar(cuentasPorCobrarId:any) {
  let companiasId = this.storage.get('companiasId')

  this.buscarParaPagarPorCuota(cuentasPorCobrarId,null)
  this.factura = `Factura: ${cuentasPorCobrarId}`
  this.servicio.calcularValoresCuentaPorCobrar(companiasId,cuentasPorCobrarId).subscribe(async (data: any)=>{
      data = JSON.parse(data['_body']).data[0]
      let calcularValoresCuentaPorCobrar = data
      this.calcularValoresCuentaPorCobrar = calcularValoresCuentaPorCobrar
    },(error)=> console.log(error))
}

buscarParaPagarPorCuota(cuentasPorCobrarId:null | any,valorPendienteInd:any) {


  this.servicio.consultarPlanDePagosCuentaPorCobrar(cuentasPorCobrarId).subscribe(async (data: any)=>{
      data = JSON.parse(data['_body']).data[0]
      let planDePagos = data

    planDePagos.forEach(cuota => {

    cuota.numeroDeCuota = cuota.nroCuota
    cuota.montoDeLaCuota = cuota.valorCuota
    cuota.valorPagado = cuota.valorPagado
    cuota.fechaVencimiento = cuota.fechaVencimiento
    cuota.estado = cuota.estadonuevo
    cuota.totalPagado = cuota.valorCuota
});

    this.planDePagos = planDePagos
  },(error)=> console.log(error))

}
formatFecha(fecha: string) {
  const date = new Date(fecha);
  return date.toISOString().split('T')[0];
}

ionViewDidLoad() {
  const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
  element.style.height = '100%';
  element.style.width = '100%';
  element.style.top = '0';
  element.style.left = '0';
  element.style.right = '0';
  element.style.bottom = '0';
}

descargarExcel() {
  if(this.planDePagos.length>0) {
    this.servicioDescargar.exportToExcel(this.planDePagos, 'plandepagos')
  }
}

}



// WEBPACK FOOTER //
// ./src/pages/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos/cuentas-por-cobrar-creditos-visualizar-plan-de-pagos.ts